<template>
  <div class="certificate-page">
    <section class="page-hero page-hero--certificate">
      <div class="page-hero__shade"></div>
      <div class="site-shell page-hero__content">
        <p class="eyebrow">CERTIFICATE VERIFICATION</p>
        <h1>证书查询</h1>
        <p>核验作品编号，查看对应的作品、匠人与确权档案。</p>
      </div>
    </section>

    <section class="certificate-query-section">
      <div class="site-shell certificate-query-layout">
        <div class="certificate-query-copy">
          <p class="eyebrow">VERIFY A WORK</p>
          <h2>查询作品档案</h2>
          <p>请输入纸质或电子证书上的编号。验证码不区分大小写，点击验证码可刷新。</p>
        </div>

        <el-form ref="queryForm" :model="queryForm" :rules="rules" label-position="top" class="certificate-query-form" @submit.native.prevent>
          <el-form-item label="证书编号" prop="certNo">
            <el-input v-model="queryForm.certNo" placeholder="例如：ZS364051782" prefix-icon="el-icon-document"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="captcha">
            <div class="captcha-field">
              <el-input v-model="queryForm.captcha" placeholder="请输入验证码" prefix-icon="el-icon-key" @keyup.enter.native="submitForm('queryForm')"></el-input>
              <button type="button" class="captcha-code" title="点击刷新验证码" @click="refreshCaptcha">{{ captchaText }}</button>
            </div>
          </el-form-item>
          <div class="certificate-query-actions">
            <el-button type="primary" @click="submitForm('queryForm')">查询证书</el-button>
            <el-button icon="el-icon-refresh" @click="resetForm('queryForm')">重置</el-button>
          </div>
        </el-form>
      </div>
    </section>

    <section v-if="certificateInfo.show" ref="QueryResults" class="certificate-result-section">
      <div class="site-shell">
        <header class="result-heading">
          <div>
            <p class="eyebrow">VERIFIED RECORD</p>
            <h2>查询结果</h2>
          </div>
          <span class="verified-mark"><i class="el-icon-circle-check"></i> 档案已核验</span>
        </header>

        <div class="certificate-result">
          <div v-if="cType === 'D' && certificateInfo.images && certificateInfo.images.length" class="certificate-record-grid">
            <div class="certificate-work">
              <div id="mySwiper" class="swiper-container certificate-work-swiper">
                <div class="swiper-wrapper">
                  <div v-for="(img, idx) in certificateInfo.images" :key="idx" class="swiper-slide">
                    <el-image :src="getImageUrl(img.path)" :alt="certificateInfo.workTitle" fit="contain" @load="onWorkImageLoad"></el-image>
                  </div>
                </div>
              </div>

              <div class="certificate-work__title">
                <p class="eyebrow">JADE WORK</p>
                <h3>{{ certificateInfo.workTitle }}</h3>
              </div>

              <dl class="certificate-facts">
                <template v-for="(item, idx) in certificateInfo.texts">
                  <div v-if="item.text !== undefined && item.text !== null && item.text !== ''" :key="idx">
                    <dt>{{ item.name }}</dt>
                    <dd>{{ item.text }}</dd>
                  </div>
                </template>
              </dl>

              <div v-if="certificateInfo.confirmation === null || certificateInfo.confirmation.status !== '3'" class="ownership-action">
                <el-button type="primary" size="small" @click="ConfirmedWorks">
                  <span v-if="getStatus('2')">确权审核中</span>
                  <span v-else-if="getStatus('4')">确权失败，重新提交</span>
                  <span v-else>确权作品</span>
                </el-button>
              </div>

              <div v-if="getStatus('3')" class="owner-record">
                <p class="eyebrow">CURRENT OWNER</p>
                <h3>确权信息</h3>
                <div class="owner-status"><i class="el-icon-circle-check"></i> 已完成确权</div>
                <div id="mySwiper-user" class="swiper-container owner-swiper">
                  <div class="swiper-wrapper">
                    <div v-for="(img, idx) in getImageList(certificateInfo.confirmation.userImage)" :key="idx" class="swiper-slide">
                      <el-image :src="img" fit="contain"></el-image>
                    </div>
                  </div>
                </div>
                <strong>{{ certificateInfo.confirmation.name }}</strong>
                <p>{{ certificateInfo.confirmation.introduce }}</p>
                <p v-if="certificateInfo.confirmation.updateTime" class="owner-time">确权时间：{{ certificateInfo.confirmation.updateTime }}</p>
              </div>

              <div v-if="certificateInfo.info && certificateInfo.info !== '<p><br></p>'" class="record-notes">
                <h3>相关资料</h3>
                <div class="rich-text" v-html="certificateInfo.info"></div>
              </div>
            </div>

            <aside class="certificate-artisan">
              <p class="eyebrow">ARTISAN</p>
              <h3>匠人信息</h3>
              <img v-if="certificateInfo.masters.avatar" class="certificate-artisan__avatar" :src="getImageUrl(certificateInfo.masters.avatar)" :alt="certificateInfo.masters.masterName">
              <div v-else class="certificate-artisan__avatar image-placeholder"><i class="el-icon-user"></i></div>
              <h4>{{ certificateInfo.masters.masterName }}</h4>
              <div v-if="certificateInfo.masters.honors" class="rich-text certificate-artisan__bio" v-html="certificateInfo.masters.honors"></div>
              <div v-if="certificateInfo.masters.profile" class="rich-text certificate-artisan__bio" v-html="certificateInfo.masters.profile"></div>
            </aside>
          </div>

          <div v-else class="certificate-image-record">
            <img class="certificate-image" :src="getImageUrl(cPath)" alt="证书原图">
          </div>

          <div v-if="!(cType === 'D' && certificateInfo.images && certificateInfo.images.length)" class="ownership-summary">
            <div v-if="certificateInfo.confirmation === null || certificateInfo.confirmation.status !== '3'" class="ownership-action">
              <el-button type="primary" size="small" @click="ConfirmedWorks">
                <span v-if="getStatus('2')">确权审核中</span>
                <span v-else-if="getStatus('4')">确权失败，重新提交</span>
                <span v-else>确权作品</span>
              </el-button>
            </div>

            <div v-if="getStatus('3')" class="owner-record owner-record--standalone">
              <p class="eyebrow">OWNERSHIP RECORD</p>
              <h3>确权信息</h3>
              <div class="owner-status"><i class="el-icon-circle-check"></i> 已完成确权</div>
              <div id="mySwiper-user" class="swiper-container owner-swiper">
                <div class="swiper-wrapper">
                  <div v-for="(img, idx) in getImageList(certificateInfo.confirmation.userImage)" :key="idx" class="swiper-slide">
                    <el-image :src="img" fit="contain"></el-image>
                  </div>
                </div>
              </div>
              <strong>{{ certificateInfo.confirmation.name }}</strong>
              <p>{{ certificateInfo.confirmation.introduce }}</p>
              <p v-if="certificateInfo.confirmation.updateTime" class="owner-time">确权时间：{{ certificateInfo.confirmation.updateTime }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="certificate-help">
      <div class="site-shell certificate-help__grid">
        <div>
          <p class="eyebrow">QUERY GUIDE</p>
          <h2>查询说明</h2>
        </div>
        <el-collapse v-model="activeHelp">
          <el-collapse-item title="如何找到证书编号？" name="1">
            <p>证书编号通常位于证书的右上角或底部，是一串由数字和字母组成的唯一编码。</p>
          </el-collapse-item>
          <el-collapse-item title="查询不到证书信息怎么办？" name="2">
            <p>请先确认编号输入无误。若仍无法查询，可能是证书尚未录入系统，请联系平台工作人员核验。</p>
          </el-collapse-item>
        </el-collapse>
      </div>
    </section>

    <el-drawer :visible.sync="open" title="作品确权" direction="ttb" size="100%" custom-class="ownership-drawer">
      <div class="ownership-form-shell">
        <p class="ownership-intro">请填写结缘作品物主资料，用于作品公开档案。请勿提交联系方式等隐私信息。</p>
        <el-form ref="form" :model="form" :rules="rules2" label-width="80px" label-position="top">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" :disabled="getStatus('2')" placeholder="请输入名称" maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="个人照片" prop="userImage">
            <div v-if="getStatus('2')" class="view-images">
              <el-image v-for="(img, idx) in getImageList(form.userImage)" :key="idx" class="images" :src="img" :preview-src-list="getImageList(form.userImage)"></el-image>
            </div>
            <ImageUpLoad v-else ref="user" :but-text="'您的个人照片'"></ImageUpLoad>
          </el-form-item>
          <el-form-item label="凭证" prop="voucherImage">
            <div v-if="getStatus('2')" class="view-images">
              <el-image v-for="(img, idx) in getImageList(form.voucherImage)" :key="idx" class="images" :src="img" :preview-src-list="getImageList(form.voucherImage)"></el-image>
            </div>
            <ImageUpLoad v-else ref="voucher" :but-text="'能证明该作品属于您的照片'"></ImageUpLoad>
          </el-form-item>
          <el-form-item label="个人介绍" prop="introduce">
            <el-input v-model="form.introduce" type="textarea" maxlength="500" show-word-limit :disabled="getStatus('2')" placeholder="请输入用于藏品公开展示的个人介绍，不得留下联系方式" :autosize="{ minRows: 3, maxRows: 7 }"></el-input>
          </el-form-item>
          <el-button v-if="!getStatus('2')" type="primary" @click="submitInfo">立即提交</el-button>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import request from '@/utils/request'
import ImageUpLoad from '@/components/ImageUpLoad/index.vue'
import Swiper from 'swiper'
import 'swiper/css/swiper.css'

function getCertificateInfo(certNo) {
  return request({ url: '/system/YddsscCertificateList/CertificateInfo/' + certNo, method: 'get' })
}

export default {
  name: 'CertificatePage',
  components: { ImageUpLoad },
  data() {
    return {
      captchaText: '',
      mySwiper: null,
      mySwiperUser: null,
      queryForm: { certNo: '', masterName: '', captcha: '' },
      open: false,
      rules: {
        certNo: [{ required: true, message: '请输入证书编号', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      activeHelp: [],
      certificateInfo: {
        show: false,
        workTitle: '',
        images: [],
        texts: [],
        info: '',
        id: '',
        name: '',
        confirmation: null,
        masters: { avatar: '', masterName: '', honors: '', profile: '' }
      },
      cType: 'D',
      cPath: '',
      form: { name: null, userImage: null, voucherImage: null, introduce: null, cId: null },
      rules2: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        introduce: [{ required: true, message: '个人介绍不能为空', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.refreshCaptcha()
    if (this.$route.query.id) {
      this.queryForm.certNo = this.$route.query.id
      this.selectZS()
    }
  },
  watch: {
    'certificateInfo.images'() {
      this.$nextTick(() => {
        if (this.mySwiper) this.mySwiper.destroy()
        if (!document.querySelector('#mySwiper')) return
        this.mySwiper = new Swiper('#mySwiper', {
          watchSlidesProgress: true,
          autoHeight: true,
          autoplay: { delay: 4000, disableOnInteraction: false },
          spaceBetween: 24,
          observer: true,
          observeParents: true
        })
      })
    },
    'certificateInfo.confirmation.userImage'() {
      this.$nextTick(() => {
        if (this.mySwiperUser) this.mySwiperUser.destroy()
        if (!document.querySelector('#mySwiper-user')) return
        this.mySwiperUser = new Swiper('#mySwiper-user', {
          watchSlidesProgress: true,
          autoHeight: true,
          autoplay: { delay: 4000, disableOnInteraction: false },
          spaceBetween: 24,
          observer: true,
          observeParents: true
        })
      })
    }
  },
  beforeDestroy() {
    if (this.mySwiper) this.mySwiper.destroy()
    if (this.mySwiperUser) this.mySwiperUser.destroy()
  },
  methods: {
    onWorkImageLoad() {
      this.$nextTick(() => {
        if (this.mySwiper) {
          this.mySwiper.update()
          this.mySwiper.updateAutoHeight(0)
        }
      })
    },
    async selectZS() {
      try {
        const res = await getCertificateInfo(this.queryForm.certNo)
        if (res.code !== 200 || !res.data) {
          this.$message.warning(res.msg || '证书不存在！')
          return
        }
        const data = res.data
        const parsed = JSON.parse(data.certificateValue)
        const valjson = parsed.valjson || {}
        this.certificateInfo.images = valjson.imageVar || []
        this.certificateInfo.texts = valjson.textVar || []
        this.cType = valjson.codeVar ? valjson.codeVar.type : ''
        this.cPath = data.certificateImage
        const workName = (valjson.textVar || []).find(item => item.name === '名称')
        this.certificateInfo.workTitle = workName && workName.text ? workName.text : data.name
        this.certificateInfo.info = data.info
        this.certificateInfo.id = data.id
        this.certificateInfo.name = data.name
        this.certificateInfo.confirmation = data.confirmation
        const masters = data.masters || {}
        this.certificateInfo.masters = {
          avatar: masters.avatar || '',
          masterName: masters.masterName || '',
          honors: masters.honors || '',
          profile: masters.profile || ''
        }
        this.certificateInfo.show = true
        this.$nextTick(() => {
          if (this.$refs.QueryResults) this.$refs.QueryResults.scrollIntoView({ behavior: 'smooth' })
        })
      } catch (error) {
        console.error('查询证书失败:', error)
        this.$message.error('查询失败，请稍后重试')
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return
        if (this.queryForm.captcha.toUpperCase() !== this.captchaText) {
          this.$message.error('验证码错误！')
          this.refreshCaptcha()
          return
        }
        const params = new URLSearchParams(window.location.search)
        if (params.has('id')) {
          params.delete('id')
          const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash
          window.history.replaceState(null, document.title, newUrl)
        }
        this.selectZS()
      })
    },
    getImageUrl(path) {
      if (!path) return ''
      return path.startsWith('http') ? path : process.env.VUE_APP_BASE_API + path
    },
    refreshCaptcha() {
      this.captchaText = Math.random().toString(36).substr(2, 4).toUpperCase()
    },
    resetForm(formName) {
      this.refreshCaptcha()
      this.$refs[formName].resetFields()
      this.certificateInfo.show = false
    },
    submitInfo() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const userFiles = this.$refs.user.$refs.upload.$data.uploadFiles
        const voucherFiles = this.$refs.voucher.$refs.upload.$data.uploadFiles
        if (!userFiles.length) {
          this.$message.error('用户照片未上传')
          return
        }
        if (!voucherFiles.length) {
          this.$message.error('凭证照片未上传')
          return
        }
        const loading = this.$loading({ lock: true, text: '确权资料上传中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
        this.form.cId = this.certificateInfo.id
        const formData = new FormData()
        formData.append('confirmation', new Blob([JSON.stringify(this.form)], { type: 'application/json' }))
        userFiles.forEach(file => formData.append('userImages', file.raw, file.name))
        voucherFiles.forEach(file => formData.append('voucherImages', file.raw, file.name))
        request.post('/system/YddsscConfirmationManagement/upload', formData).then(res => {
          if (res.code === 200) {
            this.open = false
            this.$message.success('上传成功')
            this.selectZS()
          } else {
            this.$message.error(res.msg)
          }
        }).finally(() => loading.close())
      })
    },
    ConfirmedWorks() {
      this.open = true
      const conf = this.certificateInfo.confirmation
      if (conf && conf.status === '2') {
        this.form = { name: conf.name, userImage: conf.userImage, voucherImage: conf.voucherImage, introduce: conf.introduce, cId: this.certificateInfo.id }
      } else {
        this.form = { name: null, userImage: null, voucherImage: null, introduce: null, cId: null }
      }
    },
    getStatus(status) {
      return this.certificateInfo.confirmation && this.certificateInfo.confirmation.status === status
    },
    getImageList(str) {
      if (!str) return []
      return str.split(',').map(path => process.env.VUE_APP_BASE_API + path)
    }
  }
}
</script>
